import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [{
        path: '/',
        name: 'Home/:id',
        component: Home
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('../views/Register.vue')
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () =>
            import ('../views/Logout.vue')
    },
    {
        path: '/changepsw',
        name: 'ChangePsw',
        component: () =>
            import ('../views/ChangePsw.vue')
    },
    {
        path: '/login',
        name: 'Login/:f',
        component: () =>
            import ('../views/Login.vue')
    },
    {
        path: '/list',
        name: 'List',
        component: () =>
            import ('../views/List.vue')
    },
    {
        path: '/qrCode',
        name: 'QRCode',
        component: () =>
            import ('../views/QRCode.vue')
    },
    {
        path: '/getExif',
        name: 'GetExif',
        component: () =>
            import ('../views/GetExif.vue')
    },
    {
        path: '/playControl',
        name: 'PlayControl',
        component: () =>
            import ('../views/PlayControl.vue')
    },
    {
        path: '/checkSfz',
        name: 'CheckSFZ',
        component: () =>
            import ('../views/CheckSFZ.vue')
    },
    {
        path: '/fund',
        name: 'Fund',
        component: () =>
            import ('../views/Fund.vue')
    },
    {
        path: '/turnTable',
        name: 'TurnTable',
        component: () =>
            import ('../views/TurnTable.vue')
    },
    {
        path: '/timeStampConverter',
        name: 'TimeStampConverter',
        component: () =>
            import ('../views/TimeStampConverter.vue')
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/About.vue')
    }
]

const router = createRouter({
    //history: createWebHistory(process.env.BASE_URL), //历史模式
    history: createWebHashHistory(process.env.BASE_URL), //Hash模式
    routes
})


export default router
